import { useCallback } from 'react';
import { useTranslation } from '@frontend/i18n';
import { useAlert } from '@frontend/design-system';
import { PaymentsNavAlerts } from '../../utils/helpers';

export const usePaymentAlerts = () => {
  const { t } = useTranslation('payments');
  const alert = useAlert();

  const showPaymentAlert = useCallback(
    (key: PaymentsNavAlerts) => {
      switch (key) {
        case PaymentsNavAlerts.InvalidInvoice:
          alert.error('Please select a valid invoice from the list.');
          break;
        case PaymentsNavAlerts.CreatePaymentRequest:
          alert.success(t('Payment Request Created Successfully.'));
          break;
        case PaymentsNavAlerts.CancelInvoice:
          alert.success(t('Payment Request Canceled Successfully.'));
          break;
        case PaymentsNavAlerts.InvalidPayout:
          alert.error(t('Please select a valid payout from the list.'));
          break;
        default:
          break;
      }
    },
    [alert, t]
  );

  return { showPaymentAlert };
};
